import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdi"
  },
  theme: {
    //dark: true,
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: "#ff1463",
        secondary: "#12253a", //"#b0bec5",
        accent: "#ff1463",
        error: "#b71c1c",
        primaryText: "red",
        highlight: "#ffe70a"
      },
      dark: {
        primary: "#12253a",
        background: "#12253a"
        //background: "#303030"
      }
    }
  }
});
